import { GateContext } from './gateTypes';
import { User } from '../types';

type BuildGateContextInput = {
  user: User | null;
  returnUrl?: string;
  refreshBilling: () => Promise<{ active: boolean; status?: string | null } | null>;
};

export const buildGateContext = ({
  user,
  returnUrl,
  refreshBilling,
}: BuildGateContextInput): GateContext => ({
  user,
  returnUrl,
  refreshBilling,
});
